import { createComponent } from '@mtfe/sweet';
import tpl from './dom.html';
import style from './style.less';
import Dialog, { hideDialog } from '../../../../common/Dialog/script';
import innerTpl from './innerTpl.html';

const hideCouponModal = () => {
    hideDialog();
};

const OtherCouponModal = (props = {}) => {
    const { tspMarketList = [], tspMarketAmount } = props;
    const innerData = {
        tspMarketList,
        tspMarketAmount,
    };
    const events = {
        handleClickBtn: () => {
            hideDialog();
            return false;
        },
    };
    const couponInfoContent = createComponent(innerTpl, { data: innerData, style }, events);
    const data = {
        renderOtherCoupon: Dialog({
            contentComponent: couponInfoContent,
        }),
    };
    createComponent(tpl, { data });
};

export default OtherCouponModal;
export { hideCouponModal };
